import { CampaignStatus } from '../types';
import { CitationCommonStyle } from './citationCommon';

export const CampaignsList = {
  container: {
    ...CitationCommonStyle.card,
    marginTop: '24px',
    marginBottom: '24px'
  },
  title: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: { xs: '20px', sm: '24px' },
    lineHeight: { xs: '28px', sm: '32px' },
    color: 'var(--color-primary)'
  },
  listContainer: {
    marginTop: { xs: '16px', sm: '24px' },
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  paginationContainer: {
    marginTop: '8px'
  }
};

export const CitationListItem = {
  itemContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: '1px solid var(--color-border-muted)',
    borderRadius: '6px',
    paddingY: '12px',
    paddingX: '16px',
    gap: 0,
    width: '100%'
  },
  leftSection: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    alignItems: 'center',
    width: 'auto'
  },
  title: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: { xs: '14px', sm: '16px' },
    lineHeight: { xs: '20px', sm: '24px' },
    color: 'var(--color-primary)'
  },
  chip: (status: CampaignStatus) => ({
    backgroundColor: (() => {
      if(status === 'saved') return '#e0e6ff';
      if(status === 'on_hold') return 'var(--color-bg-muted)';
      if(status === 'processing') return 'var(--color-warning-pale)';
      if(status === 'complete') return 'var(--color-bg-success-light)';
      return 'var(--color-bg-muted)';
    })(),
    paddingY: '6px',
    paddingX: { xs: '12px', sm: '16px' },
    color: (() => {
      if(status === 'saved') return '#4338CA';
      if(status === 'on_hold') return 'var(--color-text-mid)';
      if(status === 'processing') return 'var(--color-warning-orange)';
      if(status === 'complete') return 'var(--color-success-deep)';
      return 'var(--color-text-mid)';
    })(),
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: { xs: '11px', sm: '12px' },
    lineHeight: { xs: '13px', sm: '14px' }
  }),
  rightSection: {
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
    alignItems: 'center',
    width: 'auto'
  },
  date: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: { xs: '14px', sm: '18px' },
    lineHeight: { xs: '20px', sm: '28px' },
    color: 'var(--color-text-purple)'
  },
  viewDetailsButton: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: { xs: '12px', sm: '14px' },
    lineHeight: { xs: '18px', sm: '20px' },
    color: 'var(--color-primary)',
    paddingY: { xs: '8px', sm: '10px' },
    paddingX: { xs: '12px', sm: '16px' },
    width: 'auto'
  }
};

